import { Link } from "react-router-dom";
import { ArrowLeft, Mail, Clock, ShieldCheck } from "lucide-react";
import { BrandLogo } from "@/components/ui/brand-logo";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";

const SUPPORT_EMAIL = "support@reachmenow.ca";

export default function ContactUs() {
  return (
    <div className="min-h-screen bg-[#fafafa] font-body flex flex-col">
      <header className="sticky top-0 z-50 backdrop-blur-xl bg-brand-navy/95 border-b border-white/10">
        <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
          <Link to="/"><BrandLogo dark /></Link>
          <Link to="/" className="text-sm text-slate-200 hover:text-white flex items-center gap-1.5" data-testid="contactus-back-home">
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-5 py-16">
        <div className="w-full max-w-xl text-center" data-testid="contactus-page">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-brand-blue bg-blue-50 px-3 py-1.5 rounded-full">
            <Mail className="h-3.5 w-3.5" /> Contact Us
          </span>
          <h1 className="mt-6 font-heading font-extrabold text-4xl sm:text-5xl tracking-tight">We'd love to hear from you</h1>
          <p className="mt-4 text-lg text-slate-500 leading-relaxed">
            Have a question, need help, or want to partner with us? Send us an email and our team will get back to you.
          </p>

          <div className="mt-10 bg-white border border-slate-200 rounded-2xl p-8 shadow-sm">
            <div className="h-14 w-14 rounded-2xl bg-blue-50 flex items-center justify-center mx-auto">
              <Mail className="h-7 w-7 text-brand-blue" />
            </div>
            <p className="mt-5 text-sm font-semibold uppercase tracking-wide text-slate-400">Email us at</p>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="mt-1 inline-block font-heading font-bold text-2xl text-brand-blue hover:text-brand-bluehover transition-colors"
              data-testid="contactus-email"
            >
              {SUPPORT_EMAIL}
            </a>

            <div className="mt-6">
              <Button
                asChild
                className="bg-brand-orange hover:bg-brand-orangehover text-white rounded-full px-7 h-12 text-base"
                data-testid="contactus-send-email-btn"
              >
                <a href={`mailto:${SUPPORT_EMAIL}`}><Mail className="mr-2 h-4 w-4" /> Send us an email</a>
              </Button>
            </div>

            <div className="mt-7 pt-6 border-t border-slate-100 flex items-center justify-center gap-2 text-slate-600">
              <Clock className="h-4 w-4 text-brand-orange" />
              <span className="text-sm">We typically respond within <strong>48–72 business hours</strong>.</span>
            </div>
          </div>

          <p className="mt-6 text-xs text-slate-400 flex items-center justify-center gap-1.5">
            <ShieldCheck className="h-3.5 w-3.5" /> Your privacy matters — we'll never share your details.
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}
